import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import outputStateService from './outputStateService';

const initialState = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: ''
};

// Update output state
export const updateOutputState = createAsyncThunk('output-state-data/update-output-state/', async (data, thunkAPI) => {
    try {
        const token = thunkAPI.getState().auth.user.token;
        return await outputStateService.updateOutputState(data, token);
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const outputStateSlice = createSlice({
    name: 'outputState',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateOutputState.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateOutputState.fulfilled, (state, action) => {
                return {
                    ...state,
                    isSuccess: true,
                    isError: false,
                    isLoading: false,
                }
            })
            .addCase(updateOutputState.rejected, (state, action) => {
                console.log(`Failed updating output state: ${action.payload}`);
                state.isSuccess = false;
                state.isLoading = false;
                state.isError = true;
                state.message = `Failed updating output state: ${action.payload}`;
            })
    }
})

export const { reset } = outputStateSlice.actions;
export default outputStateSlice.reducer;